import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18GoogleMap00 from './C18GoogleMap00';
import C18Select01 from './C18Select01'
import {loadSiteData,loadZonesInfo,loadSitesInfo,getChannelType,privs,
} from './C18utils'
import {getParamId2,wsTrans,getPearlUsed,
} from '../utils/utils'
import {dbVals} from '../../components/utils/http'
import history from "../../history"
import {cl,az,globs,getRandomString,delay,constant} from '../../components/utils/utils';
import {lc} from '../../components/utils/landruConstants';



  var valveSvg=`<svg width="48" height="48" version="1.1" viewBox="80 169 53 38" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(0 0)">
  <path d="m121 182-0.081 1.3-3.6 0.16v1.4c0 1.6-0.13 1.7-2.3 1.7h-1.4v4.2l8.6 0.15 0.17 1.7 4.9 4e-3c2.7 2e-3 5.1 0.1 5.3 0.22 0.26 0.16 0.32 1.6 0.26 6.1l-0.071 5.9-10 0.14v1.6h-9.3l-0.38-0.92c-0.21-0.5-0.38-1.7-0.38-2.6v-1.7h-11v2.1c0 3.3 0.14 3.2-5.7 3.2h-4.9l-9.5e-5 -0.79v-0.79l-10-0.14-0.071-5.9c-0.055-4.6 0.0058-6 0.26-6.1 0.18-0.12 2.6-0.22 5.3-0.22l4.9-4e-3 0.17-1.7 8.6-0.15v-4.2h-1.4c-2.5 0-2.3 0.6-2.3-7.4 0-4.4 0.11-7.4 0.28-7.8 0.4-1.1 1.3-1.9 2.5-2.5 0.94-0.44 1.8-0.49 8.1-0.49 6.2 0 7.1 0.054 8.1 0.49 1.8 0.84 2.6 2 2.8 4.5 0.077 0.72 0.062 0.71 2.2 0.76 1.4 0.033 1.4 0.043 1.5 0.89l0.083 0.86-0.1 4.9z" fill="currentColor"/>
 </g>
</svg>`

// const valveUrl = "data:image/svg+xml;utf8," + encodeURIComponent(valveSvg);

  var weatherVaneSvg=`<svg width="24" height="24" version="1.1" viewBox="0 0 78 92" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(-69 -91)">
  <path d="m111 183c-2-2.2-0.5-6.1-0.94-9.1-3e-3 -1.8-6e-3 -3.5-8e-3 -5.3-3.6-0.77-3.6-5.7-7.9-4.1-2.9-2e-3 -5.8-8.5e-4 -8.7-1e-3 -1.7 1.5-3.2 3.6-5.1 4.7-3.5-0.056-7.1 0.17-11-0.098-1.9-2.8 3.8-6.1-0.026-9.1-2.4-3.3 3-3.1 5.1-2.8 2 0.066 4-0.11 5.9 0.1 1.8 1.4 3.2 3.5 5 4.7h12c0.69-3.6 5.6-3.6 4.1-7.8 4e-4 -2.4 1.3e-4 -4.9 2.1e-4 -7.3-9.3-0.26-18-7-20-16-3-2.4-5 5.7-7 0.35-0.89-2.4-1.5-3.2-1.5-0.092 1.5 4.9-4.2 3.2-4.2-0.36-0.42-1.3-0.29-5.2-0.82-1.7-0.88 2.5 1.7 11-2.8 6.8-7.1-8.4-4.9-22 3.7-29 6.9-5.3 18-6.9 25-1.1 3.9 2.9 4.8 8 5 13 2.6 2.4 5-5.3 5.7-7.7 0.35-2.3 3.3-6.9-0.86-5-5.3-0.4 0.18-5.7-3.3-8-0.62-2.8 3.8-2.1 3-5 1.5-2.2 4 0.48 5.5-1.9 2.3-0.23 3.5 2.5 5.8 0.64 3.6-0.45 3.3 3.9 4.1 5.2 2.7 0.89 10 3.5 4.4 5.9-4.9-0.074 3.1 7.9-3.2 8.4 0.4 2.8 4.5 6.8 4.3 11 0.49 7-2.7 14-7.4 19-3.3 3.5-7.9 5.5-13 6.1 0.025 3.7 0.014 7.3 0.02 11 3.4 0.055 2.9 5.2 6.2 4.1 5.6 6e-3 11 0.012 17 0.018 0.23-1.6-0.44-3.4 0.4-4.8 3.5-0.34 6.7 3.5 10 4.7 3.2 2.9-3.9 4.3-5.7 6-3 3.2-5.6 0.94-4.7-2.7-0.099-1.4-2.7-0.31-3.9-0.66-5 5e-3 -10 0.011-15 0.016 0.078 3.2-4.8 2.8-4.1 5.8-0.029 4 0.074 7.9-0.074 12-0.19 0.6-0.88 0.98-1.5 0.81z" fill="currentColor"/>
 </g>
</svg>`

  var plantSvg=`<svg width="48" height="48" version="1.1" viewBox="0 0 197 247" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(-2 -25)" stroke-width=".23">
  <path d="m86 272c-17-0.22-33 0.38-50-0.45-1.2-5.5-2.7-11-3.8-17-2.2-9.5-4.4-19-6.6-28-1.5-5.4-2.9-13-4-17-2.8-9.9-4.7-20-7.3-30-0.98-4.8 7-1.2 9.9-2.3 53 0.039 105-0.11 158 0.16-0.42 0.77-1.5 4.7-1.7 7.7-0.75 2.4-2.1 7.3-2.6 11-1.4 4.7-2.4 9.7-3.3 14-1.1 4.1-2.4 10-3.5 14-0.94 4-2.3 10-3.7 15-0.44 4.2-1.8 8.4-3.3 13-1 3-2 4-3.4 6.6-3.2 3.1-5.3 6.4-8.5 8.2-4.2 3-9.3 4.6-14 5.9-17 0.64-35-0.012-52 0.19zm70-8.9c0.35-1-0.97 0.96 0 0zm5.5-8c-0.082-1.1-0.72 0.75 0 0zm19-78c-1.2-0.37-0.22 0.39 0 0z" fill="#c99178"/>
  <path d="m61 154c-9.6-0.98-19-3.9-27-9.9-11-8.3-20-23-20-37-0.23-6.8-0.2-14-0.29-20 15 0.42 30-0.93 45 1.1 16 3.3 29 15 36 29 0.76 3.2 2.8 7.7 3.3 12 3.7 8-5.6 27 7.5 25 4.9 0.25-11 6e-3 -14 0.05-9.8 0.041-20-0.22-30 0.11z" fill="#96a773"/>
  <path d="m98 136c0.32-0.6 0.1 0.97 0 0zm-0.17-4.3c-2.1-20-17-37-36-42-8.7-2.6-17-1.8-26-2.4-2.7-11-4.7-27 7.5-33 15-5 30 4.3 41 14 10 8.9 14 23 13 36-0.05 8.9 0.45 21-0.29 28zm0.62-38c0.32-0.6 0.1 0.97 0 0zm0.45-2.9c0.32-0.6 0.1 0.97 0 0z" fill="#b7c27f"/>
  <path d="m16 177c-5.1-1.4-17 3.7-13-6.3 0.047-12 13-18 23-16 58-0.04 116-0.39 173 0.32 0.076 4.1 0.16 12-4.1 16-4.7 6.6-13 6.1-20 6.2-53 0.19-106-0.36-159 0.077zm180-8.1c-0.72-0.89 0.25 1.1 0 0zm-96-15c1.2-0.37 0.22 0.39 0 0zm40-0.45c0.99-0.32 0.098 0.43 0 0z" fill="#8e5b60"/>
  <path d="m98 93c-1.4-13-9.7-25-21-32-5.4-4-11-6.6-18-8 0.12-9.3 0.34-19 0.62-28 8.4-0.18 15 1.5 23 4.7 5.4 2.1 9.8 7.2 12 11 3.5 4.3 3.3 17 4.8 5.3 2.2-6.1 5.7-10 11-14 8.1-4.8 18-7.3 27-6.9-0.28 9.3 0.44 19-0.16 28-12 1.7-23 8.6-30 18-1.3 1.8-3.7 5-5 8.4-2.3 4.9-3.2 9.6-3.9 15l-0.36-1.5z" fill="#6e8865"/>
  <path d="m98 152c-0.28-14-1.2-28 6.3-40 3.2-6.7 9.2-12 14-16 4.1-2.8 8.2-5.6 13-6.7 2.9-1.7 7.3-2.1 11-2.7 13-0.52 26-0.48 39-0.2 0.47 11 1.1 23-2.8 33-2.3 7-6.9 14-13 19-4 4.6-12 9.3-18 11-7.1 3.4-17 3.1-26 3.1-8.4 0.018-17 0.026-25 0.039-0.04-0.5-0.081-0.99-0.12-1.5zm72-18c-0.81-0.86-0.28 0.89 0 0zm1.8-2c-0.27-0.82-0.56 0.8 0 0zm-73-4.6c-0.39 0.22 0.37 1.2 0 0zm-1.7-5.1c0.17-1.8 0.17 1.8 0 0z" fill="#506f5f"/>
  <path d="m98 129c-0.0065-12-0.2-23-0.25-35 1.3-6.1 2.4-13 5.6-18 5.4-9.6 14-17 24-21 2.2-0.59 4.5-1.6 8.2-2 7.8-0.71 16-0.24 24-0.38-0.041 11 0.092 22 6e-3 33-8.4 0.65-17-0.086-25 2.4-5.9 1.6-11 4.8-17 8-1.4 2.5-8.7 7.2-11 11-4.4 6.6-7.4 14-8.7 22l-0.078-0.4z" fill="#9aab75"/>
 </g>
</svg>`

  var pinSvg=`<svg width="32" height="40" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 0C7.03 0 3 4.03 3 9c0 6.75 9 15 9 15s9-8.25 9-15c0-4.97-4.03-9-9-9zm0 12.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z" fill="#EA4335"/>
</svg>`

var controllerSvg=`<svg width="48" height="48" version="1.1" viewBox="0 0 210 171" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(-1 -46)" stroke-opacity=".96">
  <rect x="1" y="46" width="210" height="171" fill="#577899" stroke-width=".26"/>
  <rect x="7.2" y="96" width="198" height="76" fill="#1a1a1a" stroke-width=".26"/>
  <g fill="#a5a5a5">
   <path d="m149 132a6.6 6.1 0 0 1-6.2-6.4 6.6 6.1 0 0 1 6.9-5.7 6.6 6.1 0 0 1 6.2 6.4 6.6 6.1 0 0 1-6.9 5.7l0.37-6.1z"/>
   <path d="m168 132a6.6 6.1 0 0 1-6.2-6.4 6.6 6.1 0 0 1 6.9-5.7 6.6 6.1 0 0 1 6.2 6.4 6.6 6.1 0 0 1-6.9 5.7l0.37-6.1z"/>
   <path d="m188 132a6.6 6.1 0 0 1-6.2-6.4 6.6 6.1 0 0 1 6.9-5.7 6.6 6.1 0 0 1 6.2 6.4 6.6 6.1 0 0 1-6.9 5.7l0.37-6.1z"/>
   <path d="m188 152a6.6 6.1 0 0 1-6.2-6.4 6.6 6.1 0 0 1 6.9-5.7 6.6 6.1 0 0 1 6.2 6.4 6.6 6.1 0 0 1-6.9 5.7l0.37-6.1z"/>
   <path d="m168 152a6.6 6.1 0 0 1-6.2-6.4 6.6 6.1 0 0 1 6.9-5.7 6.6 6.1 0 0 1 6.2 6.4 6.6 6.1 0 0 1-6.9 5.7l0.37-6.1z"/>
   <path d="m149 152a6.6 6.1 0 0 1-6.2-6.4 6.6 6.1 0 0 1 6.9-5.7 6.6 6.1 0 0 1 6.2 6.4 6.6 6.1 0 0 1-6.9 5.7l0.37-6.1z"/>
  </g>
  <rect x="165" y="72" width="39" height="5.4" fill="#ccc" stroke-width=".26"/>
  <g>
   <circle cx="21" cy="64" r="15" fill="#bbbbbc" stroke-width=".26"/>
   <g fill="#cfcfd0">
    <rect x="53" y="209" width="18" height="5.4" stroke-width=".26"/>
    <rect x="86" y="209" width="11" height="5.4" stroke-width=".21"/>
    <rect x="114" y="209" width="16" height="5.4" stroke-width=".25"/>
    <rect x="145" y="209" width="11" height="5.4" stroke-width=".21"/>
    <rect x="176" y="209" width="10" height="5.4" stroke-width=".2"/>
   </g>
   <g fill="#4da3b8" stroke-width=".26">
    <rect x="19" y="109" width="109" height="7.4"/>
    <rect x="18" y="120" width="109" height="7.4"/>
    <rect x="18" y="130" width="109" height="7.4"/>
    <rect x="18" y="141" width="109" height="7.4"/>
    <rect x="18" y="151" width="109" height="7.4"/>
   </g>
  </g>
  <g fill="#ccc" stroke-width=".26">
   <rect x="146" y="156" width="6.3" height="8.2"/>
   <rect x="165" y="156" width="6.3" height="8.2"/>
   <rect x="185" y="155" width="6.3" height="8.2"/>
  </g>
  <g>
   <rect x="144" y="166" width="8.9" height="4.7" fill="#41de3a" stroke-width=".26"/>
   <rect x="165" y="72" width="38" height="5.7" fill="#bababb" stroke-width=".26"/>
   <rect x="148" y="100" width="40" height="11" fill="#47a7bf" stroke-width=".27"/>
  </g>
 </g>
</svg>`

var pumpSvg=`<svg width="48" height="48" version="1.1" viewBox="0 0 30 40" xmlns="http://www.w3.org/2000/svg">
 <g transform="translate(-31 -119)">
  <path d="m38 158c-0.68-1.3-0.068-3.3 1.3-4.1 0.63-0.62 2.1-0.12 1.8-1.3-0.018-3.6 0.11-7.2-0.055-11-0.88 0.021-1.9-0.36-1.6-1.4v-7.4c-1.1-1.1-2.2-2.3-3.4-3.3-0.42 6.6-0.92 13-3.2 20-0.68 1.8-2.4-0.12-1.2-1.2 1.9-5.7 2.5-12 2.8-18 0.036-3-0.12-6.6 2.4-8.7 1.6-1.5 4-1.9 6.1-2 0.9-1.6 3.6-0.58 3 1.2-0.6 0.6-0.66 1.3-0.49 2.1 0.2 1.9 0.3 3.8 0.56 5.7 1.5 0.15 3.4-0.086 4.3 1.4 0.79 0.48 0.17 2.2 1.3 2 1.8 0.066 3.6-0.19 5.4 0.28 2.5 0.76 4.1 3.4 3.9 5.9 0.56 2-1.4 2.1-2.8 1.9-0.7-0.052-1.5 0.22-2-0.44-0.12-0.93 0.36-2.3-0.64-2.8-1.5-0.1-3-0.044-4.4-0.06-0.05 1.5 0.049 3-0.13 4.5-0.5 0.68-1.9-0.034-1.5 1.2v11c1.9 0.018 3.4 1.7 3.3 3.6 0.24 1-0.65 1.5-1.5 1.3h-13c-0.082-0.083-0.16-0.17-0.25-0.25zm20-9.8c-1.8-0.39-2.1-2.7-1.1-4 0.42-1.4 2.1-3.6 3-1.2 0.7 1.3 1.9 3.1 0.7 4.5-0.6 0.72-1.6 0.99-2.5 0.73z" fill="currentColor"/>
 </g>
</svg>`

var colors={
  off:"#808080",
  on:"#00CC00",
  error:"#FF0000",
  override:"#CCCC00",
  select:"#00E0FF",
  gray:"#C0C0C0",
  metar:"#00C0FF",
}

var satVaporPressure_hPa=(Tc)=>{ // over water
  return 6.112 * Math.exp((17.625 * Tc) / (243.04 + Tc));
}

var metarTime=(mTime)=>{
  let time=`0${mTime}`.slice(-6)
//   let dy=+time.slice(0,2)
  let hr=+time.slice(2,4)
  let mn=+time.slice(4,6)
  let dayMins=(60*hr+mn-(new Date()).getTimezoneOffset()+1440)%1440
  hr=Math.floor(dayMins/60)
  mn=dayMins%60
  return `${az(hr,2)}:${az(mn,2)}`
}

var toPoints=(ang)=>{
//   N: 348.75-11.25
//   NNW: 11.25-33.75
//   NW: 33.75-56.25
  return ["N","NNE","NE","ENE","E","ESE","SE","SSE",
          "S","SSW","SW","WSW","W","WNW","NW","NNW"
  ][Math.round((360+ang)*16/360)%16]
}

var overrides=[
	"None",//OVRTYPE_NONE = 0,
	"Timed",//OVRTYPE_SCHED,
	"Humid",//OVRTYPE_HUM,
	"DeHum1",//OVRTYPE_DH1,
	"DeHum2",//OVRTYPE_DH2,
	"DeHumLT",//OVRTYPE_DHLT,
	"Wind",//OVRTYPE_WIND,
	"Rain",//OVRTYPE_RAIN,
	"LoTemp",//OVRTYPE_OTEMP_LO,
	"HiTemp",//OVRTYPE_OTEMP_HI,
	"Aux",//OVRTYPE_AUX,
	"ECpH",//OVRTYPE_ECPH,
	"Fire",//OVRTYPE_FIRE,
	"Wind Break",//OVRTYPE_WB,
	"Open Field",//OVRTYPE_OF,
	"Shade House",//OVRTYPE_SH,
	"HiHum",//OVRTYPE_HI,
	"Crop 1",//OVRTYPE_CP1,
	"Crop 2",//OVRTYPE_CP2,
	"Crop 3",//OVRTYPE_CP3,
	"SP",//OVRTYPE_SP,
	"Hail",//OVRTYPE_HAIL,
	"Timed",//OVRTYPE_TIM,
	"Sched",//OVRTYPE_SCH,
	"Rain Skip",//OVRTYPE_RAINSKIP,        // Rain skip — all irrigation OFF (user-
	"Water Now",//OVRTYPE_WATERNOW,        // User-demand Water Now (highest
	"Walk Valves",//OVRTYPE_WALKVALVE,       // User-demand Walk Valve (highest
]


var c2f=(c)=>{return c*1.8+32}

var constants={
  mmHg2kpa:3.38639,
  kt2mps:0.514444,
  kt2mph:1.15078,
  lux2Ppfd:0.0185,
  m2f:3.28084,
}

var demoColors=[colors.off,colors.on,colors.error,colors.override,]

var irrInfoTypes={
  sched:["3:25pm Next Run","2 / 4 Runs Today","125 Gals Today","2 Gpm Current"],
  accum:["22 / 35 DLI","On at 3:00pm","300 Gals Today","0 Gpm Current"],
  cycle:["1:05 / 30:00 on at 75 F","5 / 26 Runs","88 Gals Today","12 Gpm Current"],
  soil:["45% / 25%","2 Runs Today","190 Gals Today","0 Gpm Current"],
  trig:["5 Runs Today","6 Gals Today","22 Gpm Current"],
  vpdi:["5.2 / 14 VPDI","VPD: 1.4","3 Runs Today","144 Gals Today","0 Gpm Current"],
}

class C18ZonesHydroRoot extends React.Component{
  mapRef=React.createRef()
  addZoneRef=React.createRef()
  azInputRef=React.createRef()
  parRef=React.createRef()
  constructor(props) {
    super(props);
    let siteId=this.props.parms.site
    this.state={
//       mapCenter:{lat:34.4,lng:-117.64},
//       hrZones:[
//         {name:"one",id:getRandomString(8),site:siteId},
//         {name:"two",id:getRandomString(8),site:siteId},
//         {name:"three",id:getRandomString(8),site:siteId}
//       ],
      showAdd:false,
      addZone:"",
      stations:[],
      markers:[],
      mapParWid:1200,
      mapParHgt:600,
      siteVol:1226,
      siteFlow:76,
    }
    this.wbRef = React.createRef();
    this.wvRef = React.createRef();
    this.rsRef = React.createRef();
    this.tbRef = React.createRef();
    this.updInt=setInterval(this.updateFlowVol,10*1000)
//     this.state.selZone=this.state.hrZones[0].id
//     cl(props)
  }

  setMapSize=({width,height})=>{
//     cl(width,height)
    this.setState({mapParWid:width,mapParHgt:height})
  }

  getResizeHook=()=>{
//     cl("getResizeHook")
    if(!this.parRef.current){return}
//     cl("hooking")
    this.ro = new ResizeObserver(entries => {
      var { width, height } = entries[0].contentRect;
//       if(width>1200){width=1200}
//       if(width<1200){}
        height=width/1.5
//       cl(height,width)
      this.setMapSize({ width, height });
      if(this.initSize){
        let is=this.initSize
        this.mapRef.current.setCenterBounds(is.center,is.bounds)
        this.initSize=false
      }
    });
//     cl(this.parRef.current)
    this.ro.observe(this.parRef.current);
//     return () => ro.disconnect();

  }

  componentDidMount() {
    this.getResizeHook()
    const markers = [
      { id: "one", lat: 37.7749, lng: -122.4194, name: "SF", svg:valveSvg, color:"red"},
      { id: "two", lat: 34.0522, lng: -118.2437, name: "LA", svg:valveSvg, color:"green" },
//       { id: "three", lat: 34.4, lng: -117.64, name: "Home", svg:valveSvg, color:"yellow" },
    ];
    this.loadInfo()

//     this.mapRef.current.setMarkers(markers);
  }

  componentWillUnmount=()=>{
    if(this.ro){this.ro.disconnect();}

    clearInterval(this.updInt)
  }

  loadStationsFromDb=async(site)=>{
    let query={siteId:site}
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/hrStations",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
//     cl(res)
    res.data.forEach(r=>{
      r.site=r.siteId
      r.zone=r.hrZone
    })
//     cl(res.data)

    return res.data
  }

  loadZonesFromDb=async(site)=>{
    let query={siteId:site}
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/hrZones",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: query})
    return res.data
  }

  loadStations=async(site)=>{
//     let pearlUsed=getPearlUsed(2)
//     cl(pearlUsed)
    let stationsDb=await this.loadStationsFromDb(site)
//     cl(stationsDb)
    let siteInfo=globs.sitesInfo.info.filter(s=>s.siteId==site)[0]
    this.siteName=siteInfo.name
//     cl(siteInfo)
//     return stationsDb
//     cl(stationsDb)
    var getZoneStations=(zInd)=>{
      let pearlUsed=getPearlUsed(zInd)
//       cl(zInd)
//       cl(pearlUsed)
      pearlUsed.map((p,i)=>{
        let ch=p.chInd
        let chType=+dbVals.z[zInd][ch]?.[chTypePid]
        let chFlow=+(dbVals.z[zInd][ch]?.[chFlowPid]||0)
//         cl(chFlow)
//         cl(chType)
//         if([2,6].includes(chType)){
        if((chType==2)||(chType==6)){
          let chName=dbVals.z[zInd][ch][chNamePid]
//           cl(zInd,ch,chNamePid,chName)
          stations.push({
            site:site,
            type:"station",
            chType:chType,
            zName:`Z${zInd}`,
            name:chName,
            color:demoColors[i%4],
            id:getRandomString(8),
            ch:ch,
            chFlow:chFlow,
            lat:0,
            lng:0,
            zInd:zInd,
            hrZone:null,
            positioned:false,
          })
        }
      })
//       cl(stations)
//       [...Array(128).keys()].map(ch=>{
//       })
    }
//     cl(dbMap)



    let chTypePid=getParamId2(1900,"configuration_channels","channelType")
    let chNamePid=getParamId2(1900,"configuration_channels","channelName")
    let chFlowPid=getParamId2(1900,"config_channels_configuration","irrFlowRate")
//     cl(chFlowPid)
//     cl(chTypePid)
    await loadZonesInfo()
    await loadSitesInfo()
    await loadSiteData(site)
//     let siteInfo=globs.sitesInfo.info.filter(s=>s.siteId==site)[0]
//     cl(siteInfo)
    let zones=globs.zonesInfo.info.filter(z=>z.siteId==site)
//     cl(zones)
    let stations=[]
    zones.forEach(z=>{
      stations.push({
        site:site,
        type:"zone",
        zName:`Z${z.siteZoneIndex}`,
        name:z.zoneName,
//         color:demoColors[i%4],
        id:getRandomString(8),
        ch:255,
//         chFlow:chFlow,
        lat:0,
        lng:0,
        zInd:z.siteZoneIndex,
//         hrZone:null,
        positioned:false,
      })
      getZoneStations(z.siteZoneIndex)// added to stations
    })
    let dbMap={}
    stationsDb.map(sd=>{dbMap[`${sd.zInd}-${sd.ch}`]=sd})
    stations.forEach(s=>{
      let dbV=dbMap[`${s.zInd}-${s.ch}`]
      if(dbV){
        Object.assign(s,{lat:dbV.lat,lng:dbV.lng,positioned:dbV.positioned,
          id:dbV.id,})
      }
    })
//     cl(stations[22]?.name)
//     cl(stations)
    return stations
  }

  loadMetarStations=async(site)=>{
    let pa=this.props.parms
    if(!site.metarVals?.stations){return{markers:[]}}
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/metarStations",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {stations:site.metarVals?.stations}})
//     cl(res)
    let stations=res.data
    let markers=stations.map(s=>{
      return({
        id:`metar_${s.id}`,
        lat:s.coord.lat,
        lng:s.coord.lng,
        name:s.id,
        svg:weatherVaneSvg,
        color:colors.metar,
        positioned:false,//p.positioned,
        draggable:false,
      })
    })
//     cl(markers)
    return {markers:markers,stations:stations}
  }

  loadIrrCycles=async()=>{
    let pa=this.props.parms
//     cl((new Date()).getTimezoneOffset())
// returns total run time, and run cycles for all irr channels
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/irrigation",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {
        siteId:pa.site,
        cmd:"getCycles",
        tz:(new Date()).getTimezoneOffset()
      }})
//     cl(res)
    return res.data
  }

  getStationStatus=(stations)=>{
    let chPosPid=getParamId2(1900,"snapshot_channels","position")
    let chOvrPid=getParamId2(1900,"snapshot_channels","channelOverride")
    stations.forEach(s=>{
      if(s.type=="station"){
        s.chPos=+dbVals.z[s.zInd][s.ch][chPosPid]
        s.chOvr=+dbVals.z[s.zInd][s.ch][chOvrPid]
      }
    })
  }

  roundTo=(val,places)=>{
    let mult=10**places
    return Math.round(val*mult)/mult
  }

  getSiteVolFlow=(stations,cycles)=>{
//     cl(stations)
//     cl(cycles)
    this.getStationStatus(stations)
    let siteFlow=0
    let siteVol=0
    stations.forEach(s=>{
      siteFlow+=(s.chPos)?s.chFlow:0
      let chInfo=cycles[`${s.zInd}-${s.ch}`]
      if(chInfo){
        s.chVol=s.chFlow*chInfo.runTime/60
        siteVol+=s.chVol
      }
    })
    return [this.roundTo(siteVol,1),this.roundTo(siteFlow,1)]
  }

  updateFlowVol=async()=>{
//     cl("upd")
    let st=this.state
    let pa=this.props.parms
    let cycles=await this.loadIrrCycles()
    let stations=st.stations.slice(0)
    let markers=st.markers.slice(0)
    let [vol,flow]=this.getSiteVolFlow(stations,cycles)
    if(pa.type=="site"){
      this.setMarkerColors(stations,markers)
    }
    this.setState({
      stations:stations,
      markers:markers,
      siteVol:vol,
      siteFlow:flow})
  }

  getMaxLatLng=(stations)=>{
//     cl(stations)
    let latMin=1000
    let latMax=-1000
    let lngMin=1000
    let lngMax=-1000
    stations.filter(s=>s.positioned)
    .forEach(s=>{
//       cl(s)
      latMin=Math.min(latMin,s.lat)
      latMax=Math.max(latMax,s.lat)
      lngMin=Math.min(lngMin,s.lng)
      lngMax=Math.max(lngMax,s.lng)
    })
//     cl(latMin,latMax,lngMin,lngMax)
    return {latMin,latMax,lngMin,lngMax}
  }

  setMarkerColors=(stations,markers)=>{
    let st=this.state
    let stInd={}
    stations.forEach(s=>{stInd[s.id]=s})
//     cl(markers)
    markers.forEach(m=>{
      let sta=stInd[m.id]
      if(sta){
        let col=colors.gray
        if(sta.chPos){col=colors.on}
        if(sta.chOvr){
          col=colors.override
          m.title=`${overrides[sta.chOvr]} Override`
        }else{
          m.title=null
        }
        sta.color=col
//         cl(sta.id,st.selStation)
        if(sta.id!=st.selStation){m.color=col}
//         cl(sta)
      }
    })
    if(this.mapRef.current){this.mapRef.current.setMarkers(markers)}

  }

  waitForMap=async()=>{
    for(let i=0;i<10;i++){
      if(this.mapRef.current){return}
      await delay(100)
    }
  }

  loadSiteInfo=async(pa)=>{
//     cl("loadSiteInfo")
//     let pa=this.props.parms
    let stations=await this.loadStations(pa.site)
//     cl(stations)
    let positioned=stations.filter(s=>s.positioned)
    let site=globs.sitesInfo.info.filter(s=>s.siteId==pa.site)[0]
    if(!site.coordinates?.coords){
      this.setState({noSiteCoords:true})
      return
    }
//     cl(site.coordinates.coords)
    let markersMS=await this.loadMetarStations(site)
    let cycles=await this.loadIrrCycles()
//     delete cycles.val
    let [vol,flow]=this.getSiteVolFlow(stations,cycles)
//     cl(positioned)
    let markers=positioned.map(p=>{
      return({
        id:p.id,
        lat:p.lat,
        lng:p.lng,
        name:p.name,
        svg:(p.type=="station")?
          ((p.chType==2)?valveSvg:pumpSvg):controllerSvg,
        color:p.color,
        positioned:p.positioned,
        draggable:false,
      })
    })
    this.setMarkerColors(stations,markers)
//     cl(markers)
//     cl(markersMS)
    markers.push(...markersMS.markers)
    this.setState({loaded:true})
    await this.waitForMap()
    this.mapRef.current.setMarkers(markers);
    let hrZones=await this.loadZonesFromDb(pa.site)
//     let site=globs.sitesInfo.info.filter(s=>s.siteId==pa.site)
//     cl(hrZones)
//     this.state.selZone=this.state.hrZones[0].id
//     let selZone=this.state.hrZones[0].id
//     cl(site)
//     cl(site.coordinates.coords)
    let bounds=this.getMaxLatLng(stations)
//     this.mapRef.current.setCenterBounds(site?.coordinates?.coords,bounds)
    this.initSize={center:site?.coordinates?.coords,bounds}
//     cl(stations)
    let stId=stations.find(s=>((s.type=="station")&&(s.positioned)))?.id||""
//     cl(stId)
    this.setState({
      mapCenter:{lat:site.coordinates?.coords?.lat,lng:site.coordinates?.coords?.lng},
      stations:stations,
      metarStations:markersMS.stations,
      cycles:cycles,
      siteVol:vol,
      siteFlow:flow,
      markers:markers,
      hrZones:hrZones,
      selStation:stId,//stations[0]?.id||"",
      selZone:hrZones[0]?.id||"",
      site:site,
    })
//     cl("loadInfo")

  }

  loadAccountInfo=async(pa)=>{
//     cl(pa)
    let siteCoords=pa.sites.filter(s=>s?.coordinates?.coords?.lat!=null)
    .map(s=>Object.assign({positioned:true},s.coordinates?.coords))
//     cl(siteCoords)
    let bounds=this.getMaxLatLng(siteCoords)
//     cl(bounds)
    let center={lat:(bounds.latMin+bounds.latMax)/2||34,
      lng:(bounds.lngMin+bounds.lngMax)/2||-118,}
//     cl(center)
    this.setState({loaded:true})
    await this.waitForMap()
//     cl("waitForMap",bounds)
//     this.mapRef.current.setCenterBounds(center,bounds)
    this.initSize={center,bounds}
//     cl(pa.sites)
    let markers=pa.sites.filter(s=>s?.coordinates?.coords?.lat!=null)
    .map(p=>{
//       cl(p)
      let coord=p?.coordinates?.coords||{}
      return({
        id:p.siteId,
        lat:coord.lat,
        lng:coord.lng,
        name:p.name,
        svg:pinSvg,
        positioned:true,
        draggable:false,
      })
    })
    this.mapRef.current.setMarkers(markers);
    this.setState({
      type:pa.type,
      mapCenter:center,//{lat:34,lng:-117.64},
      stations:[],//stations,
      metarStations:[],//markersMS.stations,
//       loaded:true,
//       cycles:cycles,
//       siteVol:vol,
//       siteFlow:flow,
//       markers:markers,
//       hrZones:hrZones,
//       selStation:stations[0]?.id||"",
//       selZone:hrZones[0]?.id||"",
//       site:site,
    })

  }

  loadInfo=async()=>{
    let pa=this.props.parms
    switch(pa.type){
      case "site":
        return await this.loadSiteInfo(pa)
      case "account":
        return await this.loadAccountInfo(pa)
    }
    cl(pa)
  }

  onMarkerMove=({id,lat,lng})=>{
    let st=this.state
    if(!st.editMode) return
//     cl(id,lat,lng)
    let marker=st.markers.filter(m=>m.id==id)[0]
    marker.lat=lat
    marker.lng=lng
    marker.positioned=true
    let stations=st.stations.slice(0)
    let station=stations.filter(s=>s.id==id)[0]
    station.positioned=true
    station.lat=lat
    station.lng=lng
//     cl(station)
    this.setState({stations:stations})
    this.lazySaveStations()
//     cl(marker)
  }

  isMetar=(station)=>{return (station?.indexOf("metar_")==0)?station.slice(6):null}

  siteMarkerClick=(e,st,id)=>{
//     cl(id)
    let pa=this.props.parms
    let markers=st.markers.slice(0)
    let oldMarker=markers.filter(m=>(m.id==st.selStation))[0]
//     cl(st.selStation)
//     cl(markers)
//     cl(oldMarker)
    if(this.isMetar(st.selStation)){
      if(oldMarker){oldMarker.color=colors.metar}
    }else{
      let oldStation=st.stations.filter(s=>s.id==st.selStation)[0]
      if(oldMarker){oldMarker.color=oldStation?.color}
    }
    let station=st.stations.filter(s=>(s.id==id))[0]
//     cl(station)
//     cl(st.stations)
    if(station?.ch==255){
      let zone=globs.zonesInfo.info.filter(z=>(
        (z.siteId==pa.site)&&(z.siteZoneIndex==station.zInd)))[0]
//       cl(zone)
      history.push(`/usa/c18/sites/${pa.site}/zones/${zone?.zoneId}`)
      return
//       return pa.handleZoneClick(e,pa.site,station.zInd)
    }
    let marker=markers.filter(m=>m.id==id)[0]
    marker.color=colors.select
    this.mapRef.current.setMarkers(markers);
    this.setState({selStation:id,markers:markers})
  }

  accountMarkerClick=(e,st,id)=>{
    cl(id)
//     cl(e)
    let pa=this.props.parms
    let site=pa.sites.filter(s=>s.siteId==id)[0]
//     cl(site)
    pa.handleSiteClick(e,site)
  }

  onMarkerClick=({e,id})=>{
    cl(e)
    let st=this.state
    let pa=this.props.parms;
    let cmds={
      site:this.siteMarkerClick,
      account:this.accountMarkerClick,
    }
    cmds[pa.type](e,st,id)
  }

  onMouseMove=({lat,lng})=>{
//     cl(lat,lng)
  }

  onIdle=({lat,lng})=>{// map center change
    this.setState({mapCenter:{lat:lat,lng:lng}})
//     cl(lat,lng)
  }



  selStation=(e)=>{
    let st=this.state
//     cl(st)
//     cl(this.props)
    let selStation=e.currentTarget.id
    let station=st.stations.filter(s=>s.id==selStation)[0]
//     cl(station)
    let markers=st.markers.slice(0)
    let oldMarker=markers.filter(m=>m.id==st.selStation)[0]
    let oldStation=st.stations.filter(s=>s.id==st.selStation)[0]
    if(oldMarker){oldMarker.color=oldStation.color}
//     cl(oldMarker)
    markers=markers.filter(m=>m.positioned)

    let marker=markers.filter(m=>m.id==selStation)[0]
//       { id: "one", lat: 37.7749, lng: -122.4194, name: "SF", svg:valveSvg, color:"red"},
    if(marker){
      marker.color=colors.select
    }else{
      markers.push({
        id:station.id,
        lat:st.mapCenter.lat,
        lng:st.mapCenter.lng,
        name:station.name,
        svg:(station.type=="zone")?controllerSvg:
        ((station.chType==2)?valveSvg:pumpSvg),
        color:colors.select,
        positioned:false,
        draggable:true,
      })
    }
//     cl(markers)
    this.mapRef.current.setMarkers(markers);
//     cl(station)
//     cl(e.currentTarget.id)
    this.setState({selStation:selStation,markers:markers})
  }

  selZone=(e)=>{
//     cl(e.currentTarget.id)
    let st=this.state
    let selZone=e.currentTarget.id
    let stations=st.stations.slice(0)
    let station=stations.filter(s=>s.id==st.selStation)[0]
    station.zone=selZone
    cl(station)
    this.lazySaveZones()
    this.lazySaveStations()
    this.setState({selZone:selZone,stations:stations})
  }

  delZone=async(e)=>{
    e.stopPropagation()
    let st=this.state
    let pa=this.props.parms
    let id=e.currentTarget.parentElement.id
    cl(st.hrZones)
    let hrZones=st.hrZones.filter(z=>z.id!=id)
    let selZone=(id==st.selZone)?hrZones[0]?.id||"":st.selZone
    this.setState({hrZones:hrZones,selZone:selZone})
    let query={siteId:pa.site,id:id}
    return await wsTrans("usa", {cmd: "cRest", uri: "/s/hrZones",
      method: "delete", sessionId: globs.userData.session.sessionId,
      body: query})
  }

  delStation=async(e)=>{
    e.stopPropagation()
    let st=this.state
    let id=e.currentTarget.parentElement.id
    let stations=st.stations.slice(0)
    let station=stations.filter(s=>s.id==id)[0]
    station.zone=null
    station.positioned=false
    let markers=st.markers.slice(0).filter(m=>m.id!=id)
    this.mapRef.current.setMarkers(markers);
    let selStation=(id==st.selStation)?stations[0].id:st.selStation
    this.lazySaveStations()
    this.setState({stations:stations,selStation:selStation,markers:markers})
//     await this.saveStationsToDb()
  }

  addZone=(e)=>{
    let st=this.state
    cl("addZone")
//     this.addZoneRef.current.focus()
//     this.saveZonesToDb()
    this.setState({ showAdd:!st.showAdd}, () => {
      this.azInputRef.current.focus();
    });
  }

  updAddZone=(e)=>{
    this.setState({addZone:e.currentTarget.value})
  }

  saveZone=(e)=>{
    let st=this.state
    let pa=this.props.parms
//     e.stopPropagation()
    let hrZones=st.hrZones.slice(0)
    hrZones.push(
      {name:st.addZone,id:getRandomString(8),siteId:pa.site}
    )
    cl("save zone")
    this.setState({showAdd:false,hrZones:hrZones,addZone:""})
    this.lazySaveZones()
  }

  escSaveZone=()=>{
    cl("esc zone")
    this.setState({showAdd:false,addZone:""})
  }

  checkSaveZone=(e)=>{
      cl(e.key)
    switch(e.key){
      case "Escape":return this.escSaveZone()
      case "Enter":return this.saveZone(e)
    }
  }

  saveStationsToDb=async()=>{
    cl("todb")
//     return
    let st=this.state
    let query={stations:st.stations}
    cl(query)
    this.setState({saving:false})
    cl("saved")
    return await wsTrans("usa", {cmd: "cRest", uri: "/s/hrStations",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: query})
  }

  lazySaveStations=()=>{
    clearTimeout(this.lssTO)
    this.lssTO=setTimeout(this.saveStationsToDb,3000)
    this.setState({saving:true})
  }

  saveZonesToDb=async()=>{
    cl("todb")
//     return
    let st=this.state
    let query={zones:st.hrZones}
    return await wsTrans("usa", {cmd: "cRest", uri: "/s/hrZones",
      method: "update", sessionId: globs.userData.session.sessionId,
      body: query})
  }

  lazySaveZones=()=>{
    clearTimeout(this.lszTO)
    this.lszTo=setTimeout(this.saveZonesToDb,1000)
  }

  toggleEdit=(e)=>{
    let st=this.state
    let markers=st.markers.slice(0)
    let editMode=e.currentTarget.checked
    markers.forEach(m=>{m.draggable=editMode})
//     cl(markers)
    this.mapRef.current.setMarkers(markers);
//     cl(e.currentTarget.checked)
    this.setState({editMode:editMode,markers:markers})

  }

  makeSvgUrl=(svg,color)=>{
    return "data:image/svg+xml;utf8,"+encodeURIComponent(svg.replace(/currentColor/g, color))
  }

  showStations=()=>{
    let st=this.state
//     cl(st.stations)
//     cl(st.stations[22].name)
    if(!st.stations){return}
    let rows=st.stations.map((s,i)=>{
//       cl(s.name)
      let hrZone="---"
      if(s.zone){
        let zone=st.hrZones.filter(z=>z.id==s.zone)[0]
//         cl(zone)
        hrZone=zone?.name||"---"
      }
//       cl(zone)
      let isSel=s.id==st.selStation
      let bg=(isSel)?"#80C0FF":null
      if(!s.name){s.name="No Name"}
      let name=(s.name.length>12)?`${s.name.slice(0,10)}...`:s.name
      let posColor=(s.positioned&&!isSel)?"#C0FFC0":null
      let svg=(s.type=="station")?valveSvg:controllerSvg
      let iconUrl=this.makeSvgUrl(svg,"#80C0FF")
//       let iconUrl="data:image/svg+xml;utf8," +
//         encodeURIComponent(svg.replace(/currentColor/g, "#80C0FF"));
      return(
        <tr key={i} id={s.id} style={{cursor:"pointer",backgroundColor:bg}}
          onClick={this.selStation}
        >
        <td style={{color:"red",fontSize:18,fontWeight:700}}
          onClick={this.delStation} title="Remove from Map"
        >
        x</td>
        <td>{!([null,255].includes(s.ch))?s.ch+1:""}</td>
        <td style={{color:"red"}}><img src={iconUrl} width="24"/></td>
        <td style={{background:posColor}}>{s.name}</td>
        </tr>
      )
    })
//         <td>{hrZone}</td>
//     cl(st.stations[22].name)
    return(
      <>
      <label>Stations</label>
      <div style={{width:350,border:"1px solid black",borderRadius:10,
        overflow:"hidden"}}>
      <div style={{height:200,padding:10,overflowY:"auto"
      }}>
      <table style={{width:"initial"}}><tbody>
      {rows}
      </tbody></table>
      </div>
      </div>
      </>
    )
  }

  showZones=()=>{
    let st=this.state
//     cl(st)
    if(!st.hrZones){return}
    let rows=st.hrZones.map((z,i)=>{
//       let bg=(z.id==st.selZone)?"#C0C0C0":null
//       cl(z.id,st.selZone)
      return(
        <tr key={i} id={z.id} style={{cursor:"pointer"/*,background:bg*/}}
        onClick={this.selZone}
        >
        <td style={{color:"red",fontSize:18,fontWeight:700}}
          onClick={this.delZone}
        >
        x</td>
        <td>{`${z.name}`}</td></tr>
      )
    })
    rows.push(
      <tr key={"add"}><td style={{color:"blue",fontSize:22,fontWeight:700,
        cursor:"pointer"}}
        onClick={this.addZone}
      >+</td>
      <td>
      <span ref={this.addZoneRef}
        style={{display:(st.showAdd)?"inline-block":"none"}}>
      <input type="text" size="10"
        onKeyUp={this.checkSaveZone}
        ref={this.azInputRef}
        value={st.addZone}
        onChange={this.updAddZone}
        style={{padding:"0px 0px 0px 5px",borderRadius:0,display:"inline-block"}}
      /><span style={{fontSize:20,fontWeight:700,color:"green",
        cursor:"pointer"}}
        onClick={this.saveZone}
        >
      &nbsp;{"\u2713"}</span></span>
      </td>
      </tr>
    )
    return(
      <>
      <label>Zones</label>
      <div style={{width:250,border:"1px solid black",borderRadius:10,
        overflow:"hidden"}}>
      <div style={{height:200,padding:10,overflowY:"auto"
      }}>
      <table style={{width:"initial"}}><tbody>
      {rows}
      </tbody></table>
      </div>
      </div>
      </>
    )
  }

  showIcon=(icon,text)=>{
    return(
      <div style={{display:"inline-flex",alignItems:"center",margin:"0px 20px 0px 0px",

      }}>
        <img src={`/images/icons/${icon}`}/>
        <span style={{fontSize:20}}>&nbsp;{text}</span>
      </div>
    )
  }

  dayMinToTime=(dayMin)=>{
    let sufx=(dayMin<720)?"am":"pm"
    let hr=(Math.floor(dayMin/60)+11)%12+1
    let mn=dayMin%60
    return `${hr}:${az(mn,2)}${sufx}`
  }

  secToHms=(sec)=>{
    let hr=Math.floor(sec/3600)
    let mn=Math.floor(sec/60)%60
    let sc=sec%60
    return `${(hr)?hr+":":""}${(hr)?az(mn,2):mn}:${az(sc,2)}`
  }

  getChannelInfo=()=>{
    var getChTypeSpecData=()=>{
//       cl(station)
      let contDayMin=Math.floor(dbVals.z[station.zInd][240][contCurTimePid]%86400/60)
//       cl(chTypes[chIrrM])
      var chDesc=""
      var runs,inTemp
      switch(chTypes[chIrrM]){
        case "sched":
          let times=[...Array(6).keys()].map(k=>{
            let pid=chCfgPids[`start_time_${k+1}`]
            return dbVals.z[station.zInd][station.ch][pid]
          })
          times=times.filter(t=>t<1440)
          times.sort((a, b) => b - a);
          let nextStartInd=times.findIndex(x=>x>contDayMin)
          let nextStartMin=times[(nextStartInd>=0)?nextStartInd:0]||0
          let nextStart=this.dayMinToTime(nextStartMin)
//           cl(nextStartMin,nextStart)
          let dailyRuns=times.length
          let doneRuns=(nextStartInd>=0)?nextStartInd:dailyRuns
          runs=+dbVals.z[station.zInd][station.ch][irrActiveCntPid]
//           cl(station)
          chDesc=`${nextStart} Next Run\n`+
          `${runs/*doneRuns*/} / ${dailyRuns} Runs Today\n`+
          `${this.roundTo((station.chVol||0),1)} Gals Today\n`+
          `${station.chFlow*((station.chPos)?1:0)} Gpm Current`
//           chDesc+="125 Gals Today\n2 Gpm Current"
//           cl(nextStart)
//           cl(chDesc)
          break
        case "accum":
          let curDli=Math.round(dbVals.z[station.zInd][station.ch][chAccumLtPid]/1e5)/10
//           let targDli=dbVals.z[station.zInd][station.ch][chCfgPids[`start_time_${k+1}`]]
          inTemp=+dbVals.z[station.zInd][240][inTempPid]
          let temp1=+dbVals.z[station.zInd][station.ch][chCfgPids["setting_1_threshold_temp"]]
          let lite1=+dbVals.z[station.zInd][station.ch][chCfgPids["setting_1_threshold_light"]]
          let temp2=+dbVals.z[station.zInd][station.ch][chCfgPids["setting_2_threshold_temp"]]
          let lite2=+dbVals.z[station.zInd][station.ch][chCfgPids["setting_2_threshold_light"]]
          runs=+(dbVals.z[station.zInd][station.ch][irrActiveCntPid]||0)
          cl(runs)
//           cl(temp1,temp2,lite1,lite2,inTemp)
          let lo=Math.min(temp1,temp2)
          let hi=Math.max(temp1,temp2)
//           cl(station.chVol)
//           inTemp=73
          inTemp=Math.max(Math.min(inTemp,hi),lo)
          let dli=Math.round((lite1+(lite2-lite1)*(inTemp-temp1)/(temp2-temp1))*10)/10
          if(isNaN(dli)){dli=0}
          chDesc=`${curDli} / ${dli} @ ${inTemp}\u00B0F\n`+
          `${runs} Runs Today\n`+
          `${this.roundTo((station.chVol||0),1)} Gals Today\n`+
          `${station.chFlow*((station.chPos)?1:0)} Gpm Current`
//           "300 Gals Today\n0 Gpm Current"
//           cl(chDesc)
          break
        case "cycle":
          inTemp=+dbVals.z[station.zInd][240][inTempPid]
          let start=+dbVals.z[station.zInd][station.ch][chCfgPids["start"]]
          let end=+dbVals.z[station.zInd][station.ch][chCfgPids["end"]]
          let onDur=+dbVals.z[station.zInd][station.ch][chCfgPids["on_duration"]]
          let offDur=+dbVals.z[station.zInd][station.ch][chCfgPids["off_duration"]]
          runs=+dbVals.z[station.zInd][station.ch][irrActiveCntPid]
          let totCycles=(end-start)/offDur
//           cl(start,end,offDur,totCycles)
          chDesc=`${this.secToHms(onDur)} / ${this.secToHms(60*offDur)} on @ ${inTemp}\n`+
          `${runs} / ${totCycles} Runs\n`+
          `${this.roundTo(station.chVol,1)} Gals Today\n`+
          `${station.chFlow*((station.chPos)?1:0)} Gpm Current`

//           cl(chDesc)
//
//           chDesc="1:05 / 30:00 on at 75\u00B0F\n5 / 26 Runs\n88 GalsToday\n12 Gpm Current"
          break
        case "soil":
          let curSmInp=Math.round(dbVals.z[station.zInd][station.ch]
            [chCfgPids["soil_moisture_input"]])
          let smSensPid=curSmInp-lc.setup_t_InputMap_INPUTIDX_SOIL1+soilMoistPid
          let smSens=+dbVals.z[station.zInd][240][smSensPid]
          let smTarget=+dbVals.z[station.zInd][station.ch][chCfgPids["soil_moisture_threshold"]]
          runs=+dbVals.z[station.zInd][station.ch][irrActiveCntPid]
//           cl(irrActiveCntPid)
//           cl(runs)
//
//           cl(smSensPid,smSens,smTarget)
//
//           cl(chCfgPids["soil_moisture_input"])
//           cl(curSmInp)
          chDesc=`${smSens}% / ${smTarget}%\n`+
          `${runs} Runs Today\n`+
          `${this.roundTo((station.chVol||0),1)} Gals Today\n`+
          `${station.chFlow*((station.chPos)?1:0)} Gpm Current`
          break
        case "vpdi":
          let curVpdi=Math.round(dbVals.z[station.zInd][station.ch][chAccumVpdPid]*10)/10
          let vpd=Math.round(dbVals.z[station.zInd][240][vpdPid]*10)/10
          let vpdTarget=+(dbVals.z[station.zInd][station.ch][chCfgPids["vpdacc_threshold"]]||0)
          runs=+dbVals.z[station.zInd][station.ch][irrActiveCntPid]
//           cl(curVpdi,vpdTarget)
          chDesc=`${curVpdi} / ${vpdTarget} kpa\n`+
          `VPD: ${vpd}\n`+
          `${runs} Runs Today\n`+
          `${this.roundTo(station.chVol,1)} Gals Today\n`+
          `${station.chFlow*((station.chPos)?1:0)} Gpm Current`
          break
        default:
          break
      }
//       cl(chDesc)
      return chDesc
    }

    let chTypes=["sched","accum","cycle","trig","soil","vpdi"]
    let st=this.state
    let pa=this.props.parms
//     cl(st)
    let chTypePid=getParamId2(1900,"configuration_channels","channelType")
    let chNamePid=getParamId2(1900,"configuration_channels","channelName")
    let chIrrMode=getParamId2(1900,"config_channels_configuration","irrigation_mode")
    let chAccumLtPid=getParamId2(1900,
      "snapshot_chan_Snapshot","accumulatedLight")
    let chAccumVpdPid=getParamId2(1900,
      "snapshot_chan_Snapshot","accvpd")
    let irrActiveCntPid=getParamId2(1900,
      "snapshot_chan_Snapshot","activeCount")
    let vpdPid=getParamId2(1900,
      "snapshots","vpd")
    let contCurTimePid=getParamId2(1900,
      "snapshots","currentTime")
    let inTempPid=getParamId2(1900,
      "snapshots","inTemperature")
    let soilMoistPid=getParamId2(1900,
      "snapshots","soilMoisture1")
//     let chCfgPidIds=
    let chCfgPids={};
    ["start_time_1","start_time_2","start_time_3",
      "start_time_4","start_time_5","start_time_6",
      "soil_moisture_threshold","soil_moisture_input","start","end",
      "setting_1_threshold_light","setting_1_threshold_temp",
      "setting_2_threshold_light","setting_2_threshold_temp",
      "vpdacc_threshold","off_duration","on_duration",]
      .map(id=>{chCfgPids[id]=getParamId2(1900,
        "config_channels_configuration",id)})
//     cl(chCfgPids)
    let station=st.stations.filter(s=>s.id==st.selStation)[0]
    if(!station) {return}
    var chIrrM
    if(station.type=="station"){
      let chType=dbVals.z[station.zInd][station.ch][chTypePid]
      let chName=dbVals.z[station.zInd][station.ch][chNamePid]
      chIrrM=dbVals.z[station.zInd][station.ch][chIrrMode]
      let zone=globs.zonesInfo.info.filter(z=>(z.siteId==pa.site)&&
        (z.siteZoneIndex==station.zInd))[0]
  //     let irrType=irrInfoTypes[chTypes]
  //     cl(irrType)
      let chFuiType=getChannelType(1900,station.zInd,station.ch)
      let chTypeName=chFuiType.split("_").slice(1)//.join(" ")
        if(chTypeName.slice(-1)==1900){chTypeName=chTypeName.slice(0,-1)}
  //     cl(chTypeName)
  //     cl(chType,station.ch,chTypes[chIrrM])
      let chInfo=getChTypeSpecData()
//       cl(chInfo)
      return{
        type:chType,
        typeName:chInfo.split("\n"),//irrInfoTypes[chTypes[chIrrM]],
        chFuiType:chFuiType,
        zInd:zone.siteZoneIndex,
        ch:station.ch,
        chTypeName:chTypeName.join(" "),
        name:chName,
        irrM:chIrrM,
        zone:zone,
      }
    }else{
      return {}
    }
  }

  makeEqList=(zInd)=>{
    let eqList=[];
    let chTypePid=getParamId2(1900,"configuration_channels","channelType")
    let chNamePid=getParamId2(1900,"configuration_channels","channelName");
    [...Array(128).keys()].map(ch=>{
//       cl(zInd,ch,chTypePid)
      let chType=dbVals.z[zInd][ch][chTypePid]
      if(chType){
        let chName=dbVals.z[zInd][ch][chNamePid]
        let fuiChType=getChannelType(1900,zInd,ch)
        eqList.push({
          chType:fuiChType,
          id:ch+1,
          name:chName,
          type:chType,
          url:`/usa/c18/fui/${fuiChType}/${zInd}-0-${ch}-0`,
        })
      }
    })
    cl(eqList)



  }

  showChannelInfo=(chanInfo)=>{
//     cl(chanInfo?.name)
    if(!chanInfo)return
    let dt=chanInfo?.typeName||[]
    let c1=Math.floor(dt.length/2+0.5)
    let col1=dt.slice(0,c1).join("\n")
    let col2=dt.slice(c1).join("\n")
//     cl(col1)
//     cl(col2)
    return(
      <>
        <div style={{whiteSpace:"pre-line",}}>{col1}</div>
        <div>{col2}</div>
      </>
    )
  }

  openEquipConfig=(chType,zInd,unit,chan)=>{
    cl(chType,zInd,unit,chan)
    let url=`/usa/c18/fui/${chType}/${zInd}-${unit}-${chan}-0`
    history.push({
      pathname: url,
    },
    {
      eqList:this.makeEqList(zInd)
    });
  }

  hideShowEquip=()=>{
    cl("hideShowEquip")
  }

  showChanPane=(chanInfo)=>{
//     cl(-7%4)
    var addSens=(name,src,val)=>{
      if(src!=null){chanInfo.typeName.push(`${name}: ${val}`)}
    }
    let st=this.state
    let metar=this.isMetar(st.selStation)
    if(metar){

      let station=st.metarStations.filter(st=>st.id==metar)[0]
//       cl(station)
      let v=station.vals
      let coord=station.coord
//       cl(coord)
      let gust=(v.wind_gust_kt)?`, Gust ${Math.round(v.wind_gust_kt*constants.kt2mph)}`:""
      chanInfo={typeName:[]}
      addSens("Temp",v.temperature_c,`${Math.round(c2f(v.temperature_c))} \u00B0F`)
      addSens("Hum",v.h2oVp,`${Math.round(100*v.h2oVp/satVaporPressure_hPa(v.temperature_c))}%`)
      addSens("Light",v.light_lux,`${Math.round(v.light_lux*constants.lux2Ppfd)} ppfd`)
      addSens("Wind",v.wind_speed_kt,`${Math.round(v.wind_speed_kt*constants.kt2mph)}\
${gust} mph @ ${(v.wind_dir_deg+360)%360}\u00B0, ${toPoints(v.wind_dir_deg)}`)
      addSens("Baro",v.altimeter_inHg,`${v.altimeter_inHg} inHg`)
      addSens("Altitude",coord.alt,`${Math.round(coord.alt*constants.m2f)} feet`)
      return(
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{fontSize:24,fontWeight:700}}
            >Metar {station.id} @ {metarTime(v.time)}</div>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto",
              gap: 16,
              height:"fix-content",
              whiteSpace:"pre-line",
            }}
          >
            {this.showChannelInfo(chanInfo)}
          </div>
        </>
      )
    }else{
      return(
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{fontSize:24,fontWeight:700}}>
              {chanInfo?.zone?.zoneName||""} / {chanInfo?.name}:&nbsp;
                {chanInfo?.chTypeName}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "auto auto",
              gap: 16,
              height:"fix-content",
              whiteSpace:"pre-line",
             fontSize:16,
             fontWeight:300,
            }}
          >
            {this.showChannelInfo(chanInfo)}
          </div>
            </div>
            <div>
              <button className="filled" type="button" style={{width:120}}
                onClick={e=>this.openEquipConfig(chanInfo?.chFuiType,
                  chanInfo?.zInd,0,chanInfo?.ch)}
              >Edit</button><br/>
            </div>
          </div>
        </>
      )
    }
//               <button className="filled" type="button" style={{width:120,marginTop:5}}
//                 onClick={e=>this.openEquipConfig(chanInfo?.chFuiType,
//                   chanInfo?.zInd,0,chanInfo?.ch)}
//               >Water Now</button>
  }

  setSelValue=(e,v)=>{
    this.setState(v)
  }

  showWaterBudget=()=>{
    let st=this.state
    if(!st.showWb){return}
    let tbr=this.wbRef.current
    if(!tbr){return}
    let opts=[...Array(10).keys()].map(k=>{
      return {v:k,t:k}
    })
    return(
      <div style={{position:"absolute",
        width:(tbr?.offsetWidth),
        /*height:200,*/background:"white",zIndex:1,
        border:"1px solid black",borderRadius:10,padding:10,
      }}>
      <label>Water Budget</label>
      <input type="text" size="5"/><br/>
      <C18Select01 parms={{
        label:"Number of Days",
        valueName:"wbDays",
        wbDays:st.wbDays,
        opts:opts,
        onChange:this.setSelValue//this.onChange,
      }}/>
      <button className="filled" type="button">Set</button>
      </div>
    )
  }

  showWalkValves=()=>{
    let st=this.state
    if(!st.showWv){return}
    let tbr=this.wvRef.current
    if(!tbr){return}
    let opts=[...Array(10).keys()].map(k=>{
      return {v:k,t:k}
    })
    return(
      <div style={{position:"absolute",
        width:(tbr?.offsetWidth),
        /*height:200,*/background:"white",zIndex:1,
        border:"1px solid black",borderRadius:10,padding:10,
      }}>
      <label>Water Budget</label>
      <input type="text" size="5"/><br/>
      <C18Select01 parms={{
        label:"Number of Days",
        valueName:"wbDays",
        wbDays:st.wbDays,
        opts:opts,
        onChange:this.setSelValue//this.onChange,
      }}/>
      <button className="filled" type="button">Set</button>
      </div>
    )
  }

  showRainSkip=()=>{
    let st=this.state
    if(!st.showRs){return}
    let tbr=this.rsRef.current
    if(!tbr){return}
    let opts=[...Array(10).keys()].map(k=>{
      return {v:k,t:k}
    })
    return(
      <div style={{position:"absolute",
        width:(tbr?.offsetWidth),
        /*height:200,*/background:"white",zIndex:1,
        border:"1px solid black",borderRadius:10,padding:10,
      }}>
      <label>Water Budget</label>
      <input type="text" size="5"/><br/>
      <C18Select01 parms={{
        label:"Number of Days",
        valueName:"wbDays",
        wbDays:st.wbDays,
        opts:opts,
        onChange:this.setSelValue//this.onChange,
      }}/>
      <button className="filled" type="button">Set</button>
      </div>
    )
  }

  toggleVal=(id)=>{
    let st=this.state
    cl(st)
    cl(st.showWb)
    this.setState({[id]:!(st[id]||0)})
  }

  togWb=()=>{this.toggleVal("showWb")}
  togWv=()=>{this.toggleVal("showWv")}
  togRs=()=>{this.toggleVal("showRs")}

  showAccount=()=>{
    let st=this.state
//     cl("showAccount")
    return(
        <div id="content-area">
          <section className={"link4"} ref={this.parRef}>
            <C18GoogleMap00
              ref={this.mapRef}
              wid={`${st.mapParWid}px`}
              hgt={`${st.mapParHgt}px`}
              lat={st.mapCenter?.lat||0}
              lng={st.mapCenter?.lng||0}
              zoom="12"
              mapId="terrain"
              onMarkerMove={this.onMarkerMove}
              onMarkerClick={this.onMarkerClick}
              onMouseMove={this.onMouseMove}
              onIdle={this.onIdle}
            />
          </section>
        </div>
    )
  }

  showSite(){
    let st=this.state
    let pa=this.props.parms
    let site=globs.sitesInfo.info.filter(s=>s.siteId==pa.site)[0]
    let isSuper=privs("super","",constant.AREA_PRIVS_READ)!=0
    let mtv=null//site.metarVals
//     cl(mtv)
//     cl(site)
    let chanInfo=this.getChannelInfo()
    let butWidth=(this.tbRef.current?.clientWidth||0)/3
//     cl(chanInfo)
//     cl(this.state)
    return(
      <div>
      <table style={{width:"initial",marginLeft:32}}><tbody>
      <tr><td><span style={{fontSize:36,fontWeight:700}}>
      {this.siteName} Zones</span></td>
      {isSuper&&
        <>
          <td><input type="checkbox"
            style={{marginLeft:20,width:16,height:16,borderRadius:10}}
            checked={st.editMode||false}
            onChange={this.toggleEdit}
          />
          </td>
          <td style={{fontSize:"2rem",fontWeight:700}}>
          Edit<span style={{marginLeft:100,color:"green",
            display:(st.saving)?"inline-block":"none"
          }}>Save</span></td>
        </>
      }
      </tr>
      </tbody></table>



        <div id="content-area">
            <section className={"link4"} ref={this.parRef}>
            {mtv&&
              <div style={{border:"1px solid black",borderRadius:10,marginBottom:32,
                display:(st.editMode)?"none":"block",padding:"10px 10px 0px 10px",
              }}>
              {this.showIcon("rain.svg","")}
              {this.showIcon("snow.svg","")}
              {this.showIcon("temp.svg",`${Math.round(c2f(mtv?.temp_c))} \u00B0F`)}
              {this.showIcon("water.svg",`${Math.round(mtv?.hum_pct)}%`)}
              {this.showIcon("light.svg",`${Math.round(mtv?.light_ppfd)} ppfd`)}
              {this.showIcon("waterVolume.svg",`${st.siteVol} gals`)}
              {this.showIcon("flow.svg",`${st.siteFlow} gpm`)}
              <table ref={this.tbRef} style={{marginTop:10}}><tbody>
              </tbody></table>
              </div>
            }
            <C18GoogleMap00
              ref={this.mapRef}
              wid={`${st.mapParWid}px`}
              hgt={`${st.mapParHgt}px`}
              lat={st.mapCenter?.lat||0}
              lng={st.mapCenter?.lng||0}
              zoom="12"
              mapId="terrain"
              onMarkerMove={this.onMarkerMove}
              onMarkerClick={this.onMarkerClick}
              onMouseMove={this.onMouseMove}
              onIdle={this.onIdle}
            />
            {st.editMode&&
              <table style={{width:"initial",marginTop:12}}><tbody>
                <tr><td>{this.showStations()}</td></tr>
              </tbody></table>
            }
            {st.stations.length&&st.selStation&&
              <div style={{border:"1px solid black",borderRadius:10,marginTop:32,
                display:(st.editMode)?"none":"block",padding:10
              }}>
              {this.showChanPane(chanInfo)}
              </div>
            }
          </section>
        </div>
      </div>
    )
//             <tr>
//             <td ref={this.wbRef} style={{position:"relative",width:butWidth}}>
//             <button className="filled" type="button"
//             onClick={this.togWb}
//             style={{width:"100%",boxSizing:"border-box",}}>Water Budget</button>
//             {this.showWaterBudget()}
//             </td>
//             <td ref={this.wvRef}>
//             <button className="filled" type="button"
//             onClick={this.togWv}
//             style={{width:"100%"}}>Walk the Valves</button>
//             {this.showWalkValves()}
//             </td>
//             <td ref={this.rsRef}>
//             <button className="filled" type="button"
//             onClick={this.togRs}
//             style={{width:"100%"}}>Rain Skip</button>
//             {this.showRainSkip()}
//             </td>
//             </tr>
//     <td>{this.showZones()}</td>
  }

  render(){
    let st=this.state
    let pa=this.props.parms
    if(st.noSiteCoords){return null}
    if(!this.ro){this.getResizeHook()}
//     cl(pa)
    if(st.loaded){
      switch(pa.type){
        case "account":
          return this.showAccount()
        case "site":
          return this.showSite()
      }
    }else{
      return <LoadingSpinner message="Loading..." />
    }


  }
}

export default C18ZonesHydroRoot;
